import { StatusBadge } from '@/components/common/StatusBadge';
import {
  APPROVAL_STATUS_LABELS,
  LEAVE_APPROVAL_STATUS_TONE,
} from '../constants/leaveApplication.constants';
import type { ApprovalStatus } from '../types/leaveApplication.types';

interface LeaveApplicationStatusBadgeProps {
  status: ApprovalStatus;
}

export function LeaveApplicationStatusBadge({ status }: LeaveApplicationStatusBadgeProps) {
  return (
    <StatusBadge tone={LEAVE_APPROVAL_STATUS_TONE[status]}>
      {APPROVAL_STATUS_LABELS[status]}
    </StatusBadge>
  );
}
